import {
  WorkspaceSegments,
  normalizeWorkspaceSegment,
} from "../../constants/workspaceSegments.js";

const SEGMENT_ALIASES = Object.freeze({
  passengertransport: WorkspaceSegments.PassengerTransport,
  passenger_transport: WorkspaceSegments.PassengerTransport,
  generic: WorkspaceSegments.Generic,
  autoparts: WorkspaceSegments.AutoParts,
  auto_parts: WorkspaceSegments.AutoParts,
});

export function normalizeHelpSegment(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const compact = s.toLowerCase().replace(/[\s_-]+/g, "");
  if (SEGMENT_ALIASES[compact]) return SEGMENT_ALIASES[compact];
  if (SEGMENT_ALIASES[s.toLowerCase()]) return SEGMENT_ALIASES[s.toLowerCase()];
  return normalizeWorkspaceSegment(s);
}

/** Mesma regra do menu lateral (Sidebar.js). */
export function navDefMatchesSegment(def, workspaceSegment) {
  const seg = normalizeWorkspaceSegment(workspaceSegment);
  if (Array.isArray(def?.segments) && def.segments.length > 0) {
    return def.segments.map(normalizeWorkspaceSegment).includes(seg);
  }
  return true;
}

/**
 * Filtra linhas do inventário (feature-map.csv) pelo segmento do workspace.
 * Espelha Dashboard (abas Produtos vs Passagens) e coluna `segment` do CSV.
 */
export function featureItemMatchesSegment(item, workspaceSegment) {
  const seg = normalizeWorkspaceSegment(workspaceSegment);
  const feature = String(item?.feature || "");
  const featureLc = feature.toLowerCase();

  const explicit = normalizeHelpSegment(item?.segment);
  if (explicit && explicit !== seg) return false;

  if (featureLc.startsWith("aba: produtos")) {
    return seg === WorkspaceSegments.Generic || seg === WorkspaceSegments.AutoParts;
  }

  if (featureLc.includes("passagens")) {
    return seg === WorkspaceSegments.PassengerTransport;
  }

  return true;
}

export function faqItemMatchesSegment(item, workspaceSegment) {
  const seg = normalizeWorkspaceSegment(workspaceSegment);
  if (Array.isArray(item?.segments) && item.segments.length > 0) {
    return item.segments.map(normalizeWorkspaceSegment).includes(seg);
  }
  if (Array.isArray(item?.excludeSegments) && item.excludeSegments.length > 0) {
    return !item.excludeSegments.map(normalizeWorkspaceSegment).includes(seg);
  }
  return true;
}

export function dashboardTabOrderForSegment(workspaceSegment) {
  const seg = normalizeWorkspaceSegment(workspaceSegment);
  if (seg === WorkspaceSegments.PassengerTransport) {
    return ["Visão geral", "Clientes", "Passagens rodoviárias", "Vendas", "Pesquisas"];
  }
  return ["Visão geral", "Clientes", "Produtos", "Vendas", "Pesquisas"];
}

export function isPassengerTransportSegment(workspaceSegment) {
  return normalizeWorkspaceSegment(workspaceSegment) === WorkspaceSegments.PassengerTransport;
}
